import React from 'react';
import {Link, withRouter} from "react-router-dom";
import { connect } from "react-redux";
import { Carousel, Container, Row, Col } from 'react-bootstrap';
import * as generalActions from "../../../../redux/action/general.action";
import style from "./Detail.module.scss";
import * as propertyActions from "../../../../redux/action/property.action";
import Mapbox from "../../../../components/Mapbox/Mapbox.component";
import {getFilterName, numberWithCommas, timeAgo} from "../../../../helper/functions";
import history from "../../../../helper/history";
import {BASE_URL} from "../../../../environment/environment";
import * as urls from "../../../../config/urls";
import restRoomTypeOptions from '../../../../asset/data/restRoomTypes';
import propertyDirectionOptions from '../../../../asset/data/propertyDirection';
import {RadioButton} from "../../../../components";

class Detail extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showMap: false,
      facilityTree: []
    };
  };

  async componentDidMount() {
    const { setFilterBar, selectedProperty } = this.props;

    await setFilterBar(false);
    this.setState({showMap: true});
    if (selectedProperty && Object.keys(selectedProperty).length) {
      this.createFacilityModel(selectedProperty.facilities);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.selectedProperty !== this.props.selectedProperty) {
      this.createFacilityModel(nextProps.selectedProperty.facilities);
    }
  }

  createFacilityModel(facilities) {
    let tree = [];
    facilities.map((facility) => {
      let treeIndex = tree.findIndex(t => t.id === facility.facilityGroup.id);
      if (treeIndex >= 0) {
        tree[treeIndex].facilities.push({id: facility.id, title: facility.title});
      } else {
        tree.push({...facility.facilityGroup, facilities: []});
      }
    });
    this.setState({facilityTree: tree});
  }

  closeDetail() {
    const paths = getFilterName();
    history.push(`/${paths[0]}${history.location.search}`);
  }

  render() {
    const { showMap, facilityTree } = this.state;
    const { selectedProperty } = this.props;
    const { propertyType } = selectedProperty;

    return (
        <div className={style.wrapper}>
          <div className={`text-right ${style.property_container} scroll scroll__default`}>
            <div className={`d-flex ${style.header}`}>
              <div className={`d-flex align-items-center ${style.close}`} onClick={() => {this.closeDetail()}}>
                <i className={'icon-close'} />
                <span>بستن</span>
              </div>
              {/*<div className={`d-flex align-items-center ${style.new_tab}`}>
                <i className={'icon-new-tab'} />
                <span>بازکردن پنجره جدید</span>
              </div>*/}
            </div>
            <div className={`${style.body}`}>
              {
                selectedProperty.files && !!selectedProperty.files.length && (
                    <Carousel className={style.carousel} indicators={false} controls={selectedProperty.files.length > 1}>
                      {
                        selectedProperty.files.map((file, index) => {
                          return (
                              <Carousel.Item key={index}>
                                <img className={`d-block w-100 ${style.property_carousel_image}`}
                                     src={`${BASE_URL}${urls.FILE_BY_UUID}/${file.id}`}
                                     alt="file"
                                />
                              </Carousel.Item>
                          )
                        })
                      }
                    </Carousel>
                )
              }
              <Container className={'p-0'}>
                <Row className={'no-gutters'}>
                  <Col xl={7} className={'pl-2'}>
                    <Row className={`${style.actions}`}>
                      {/*<Col sm={3}>
                        <div className={`d-flex align-items-center justify-content-center ${style.item}`}>
                          <i className={'icon-tour-360'} />
                          <span>تور ۳۶۰ درجه</span>
                        </div>
                      </Col>*/}
                      <Col lg={4}>
                        <div className={`${style.item}`}>
                          <a className={'d-flex align-items-center justify-content-start'} href={`https://wa.me/?text=${window.location.origin}${window.location.pathname}%0D%0A${selectedProperty.propertyName}`} target={"_blank"}>
                            <i className={'icon-share'} />
                            <span>اشتراک گذاری</span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                    <Row className={`${style.title}`}>
                      <Col lg={8}>
                        <span className={`${style.name}`}>{selectedProperty.propertyName}</span>
                      </Col>
                      <Col lg={4} className={'text-lg-left'}>
                        <span className={`${style.code}`}>
                          کد ملک: {selectedProperty.propertyCode ? selectedProperty.propertyCode : '-'}
                        </span>
                      </Col>
                    </Row>
                    <Row className={`${style.date}`}>
                      <Col>
                        <span>{timeAgo(selectedProperty.changedDate)}</span>
                      </Col>
                    </Row>
                    <Row className={`${style.base_info} ${style.first}`}>
                      <Col>
                        <span className={`${style.key}`}>{selectedProperty.transactionType === 'RENT' ? 'مبلغ قرض الحسنه': 'مبلغ کل'}</span>
                      </Col>
                      <Col className={'text-left'}>
                        <span className={`${style.price}`}>{selectedProperty.overallPrice ? numberWithCommas(selectedProperty.overallPrice) : 'توافقی'}</span>
                        {
                          selectedProperty.overallPrice && (
                              <span className={`${style.label}`}>&nbsp;تومان</span>
                          )
                        }
                      </Col>
                    </Row>
                    {
                      selectedProperty.segmentPrice && (
                          <Row className={`${style.base_info} ${style.first}`}>
                            <Col>
                              <span className={`${style.key}`}>{selectedProperty.transactionType === 'RENT' ? 'مبلغ اجاره': 'مبلغ متری'}</span>
                            </Col>
                            <Col className={'text-left'}>
                              <span className={`${style.price}`}>{selectedProperty.segmentPrice ? numberWithCommas(selectedProperty.segmentPrice) : 'توافقی'}</span>
                              {
                                selectedProperty.segmentPrice && (
                                    <span className={`${style.label}`}>&nbsp;تومان</span>
                                )
                              }
                            </Col>
                          </Row>
                      )
                    }
                    <Row className={`${style.base_info}`}>
                      <Col>
                        <span className={`${style.key}`}>موقعیت</span>
                      </Col>
                      <Col className={'text-left'}>
                        <span className={`${style.value}`}>{selectedProperty.address || 'آدرس وارد نشده است'}</span>
                      </Col>
                    </Row>
                    <Row className={`${style.base_info}`}>
                      <Col>
                        <span className={`${style.key}`}>سن بنا</span>
                      </Col>
                      <Col className={'text-left'}>
                        <span className={`${style.value}`}>{selectedProperty.age ? selectedProperty.age : '-'}</span>
                      </Col>
                    </Row>
                    <Row className={`${style.features}`}>
                      <Col xs={12} className={`mb-3`}>
                        <span className={`${style.title}`}>ویژگی های ملک</span>
                      </Col>
                      <Col md={6} lg={4} xl={3}>
                        <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                          <i className={'icon-meter'} />
                          <span className={`${style.key}`}>متراژ:</span>
                          <span className={`${style.value}`}>{selectedProperty.foundation ? `${selectedProperty.foundation} متر` : '-'}</span>
                        </div>
                      </Col>
                      <Col md={6} lg={4} xl={3}>
                        <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                          <i className={'icon-elevator'} />
                          <span className={`${style.key}`}>آسانسور:</span>
                          <span className={`${style.value}`}>{selectedProperty.elevator ? 'دارد' : 'ندارد'}</span>
                        </div>
                      </Col>
                      <Col md={6} lg={4} xl={3}>
                        <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                          <i className={'icon-beds'} />
                          <span className={`${style.key}`}>اتاق:</span>
                          <span className={`${style.value}`}>{selectedProperty.propertyBedrooms ? selectedProperty.propertyBedrooms : '-'}</span>
                        </div>
                      </Col>
                      <Col md={6} lg={4} xl={3}>
                        <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                          <i className={'icon-parking'} />
                          <span className={`${style.key}`}>پارکینگ:</span>
                          <span className={`${style.value}`}>{selectedProperty.parkingSpace ? selectedProperty.parkingSpace : '-'}</span>
                        </div>
                      </Col>
                    </Row>
                    {
                      selectedProperty.description && (
                        <Row className={`${style.features}`}>
                          <Col xs={12} className={`mb-3`}>
                            <span className={`${style.title}`}>توضیحات</span>
                          </Col>
                          <Col xs={12}>
                            <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                              <span className={`${style.key}`}>{selectedProperty.description}</span>
                            </div>
                          </Col>
                        </Row>
                      )
                    }
                    <Row className={`${style.features}`}>
                      <Col xs={12} className={`mb-3`}>
                        <span className={`${style.title}`}>سایر ویژگی ها</span>
                      </Col>
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'OLD_PROPERTY' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>تعداد طبقات:</span>
                                <span className={`${style.value}`}>{selectedProperty.totalFloors ? selectedProperty.totalFloors : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>طبقه:</span>
                                <span className={`${style.value}`}>{selectedProperty.propertyFloor ? selectedProperty.propertyFloor : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'OLD_PROPERTY' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>تعداد واحد:</span>
                                <span className={`${style.value}`}>{selectedProperty.totalUnitsPerFloor ? selectedProperty.totalUnitsPerFloor : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>واحد:</span>
                                <span className={`${style.value}`}>{selectedProperty.propertyUnit ? selectedProperty.propertyUnit : '-'}</span>
                              </div>
                            </Col>
                        )
                      }

                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>بالکن:</span>
                                <span className={`${style.value}`}>{selectedProperty.balcony ? 'دارد' : 'ندارد'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>نوع کابینت:</span>
                                <span className={`${style.value}`}>{selectedProperty.cabinet ? selectedProperty.cabinet.title : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>Open:</span>
                                <span className={`${style.value}`}>{selectedProperty.open ? 'دارد' : 'ندارد'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>نوع کفپوش:</span>
                                <span className={`${style.value}`}>{selectedProperty.flooring ? selectedProperty.flooring.title : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>نوع سرویس:</span>
                                <span className={`${style.value}`}>{selectedProperty.restroomType ? restRoomTypeOptions.find(i => selectedProperty.restroomType === i.value).label : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>انباری:</span>
                                <span className={`${style.value}`}>{selectedProperty.wareHouse ? 'دارد' : 'ندارد'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>جهت ملک:</span>
                                <span className={`${style.value}`}>{selectedProperty.propertyDirection ? propertyDirectionOptions.find(i => selectedProperty.propertyDirection === i.value).label : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'OLD_PROPERTY' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>مساحت زمین:</span>
                                <span className={`${style.value}`}>{selectedProperty.area ? selectedProperty.area : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>حیاط اختصاصی:</span>
                                <span className={`${style.value}`}>{selectedProperty.privateYard ? 'دارد' : 'ندارد'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>حیاط خلوت:</span>
                                <span className={`${style.value}`}>{selectedProperty.backyard ? 'دارد' : 'ندارد'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'OLD_PROPERTY' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>تخلیه:</span>
                                <span className={`${style.value}`}>{selectedProperty.empty ? 'بله' : 'خیر'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>نما:</span>
                                <span className={`${style.value}`}>{selectedProperty.facade ? selectedProperty.facade.title : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'OLD_PROPERTY' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>عرض گذر:</span>
                                <span className={`${style.value}`}>{selectedProperty.passageWidth ? selectedProperty.passageWidth : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'APARTMENT' || propertyType === 'VILLA' || propertyType === 'TENEMENT' || propertyType === 'OLD_PROPERTY' || propertyType === 'S_OFFICE' || propertyType === 'M_OFFICE' || propertyType === 'COMMERCIAL' || propertyType === 'STORE' || propertyType === 'SUITE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>طول بر</span>
                                <span className={`${style.value}`}>{selectedProperty.sideLength ? selectedProperty.sideLength : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'OLD_PROPERTY' || propertyType === 'VILLA' || propertyType === 'TENEMENT') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>اصلاحی</span>
                                <span className={`${style.value}`}>{selectedProperty.corrective ? selectedProperty.corrective : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>نیم طبقه</span>
                                <span className={`${style.value}`}>{selectedProperty.halfFloor ? selectedProperty.halfFloor : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'OLD_PROPERTY') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>پهنه</span>
                                <span className={`${style.value}`}>{selectedProperty.width ? selectedProperty.width : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'OLD_PROPERTY') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>تراکم</span>
                                <span className={`${style.value}`}>{selectedProperty.density ? selectedProperty.density : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                      {
                        (propertyType === 'COMMERCIAL' || propertyType === 'STORE') && (
                            <Col md={6} lg={4} className={'mb-3'}>
                              <div className={`d-flex align-items-center justify-content-right ${style.item}`}>
                                <span className={`${style.key}`}>ارتفاع</span>
                                <span className={`${style.value}`}>{selectedProperty.height ? selectedProperty.height : '-'}</span>
                              </div>
                            </Col>
                        )
                      }
                    </Row>

                      {
                        facilityTree.map(facilityGroup => {
                          return (
                            !!facilityGroup.facilities.length && (
                              <Row key={facilityGroup.id} className={`${style.other_features}`}>
                                <Col xs={12} className={`mb-2`}>
                                  <span className={`${style.title}`}>امکانات {facilityGroup.title}</span>
                                </Col>
                                <Col xs={12} className={`mb-2`}>
                                {
                                  facilityGroup.facilities.map(facility => {
                                    return (
                                        <RadioButton key={facility.id}
                                                     text={facility.title}
                                                     isChecked={true}
                                                     onClick={() => {}}
                                        />
                                    )
                                  })
                                }
                                </Col>
                              </Row>
                            )
                          )
                        })
                      }
                  </Col>
                  <Col xl={5}>
                    <div className={style.advisor_container}>
                      <div className={style.advisor_title}>
                        <span>با انتخاب مشاور، بررسی هوشمندانه ای داشته باشید</span>
                      </div>
                      <div className={style.advisors}>
                        {
                          selectedProperty.advisors && !!selectedProperty.advisors && (
                            selectedProperty.advisors.map((advisor) => {
                              return (
                                <div className={`${style.item} d-flex`}>
                                  <div>
                                    {
                                      advisor.avatar ? (
                                        <img src={`${BASE_URL}${urls.FILE_BY_UUID}/${advisor.avatar}?size=thumbnails`} alt="مشاور" />
                                      ) : (
                                        <span className={`${style.no_user} d-flex justify-content-center align-items-center`}>
                                          <i className={'icon-avatar'} />
                                        </span>
                                      )
                                    }
                                  </div>
                                  <div className={`d-flex flex-column ${style.name}`}>
                                    <span>
                                      {advisor.alias || '---'}
                                    </span>
                                  </div>
                                  <div className={`d-flex flex-column`}>
                                    <a href={`tel:${advisor.mobileNumber}`} className={`d-flex align-items-center justify-content-between ${style.phone}`}>
                                      <span>{advisor.mobileNumber}</span>
                                      <i className={'icon-mobile'} />
                                    </a>
                                    <Link to={`/advisor-profile/${advisor.id}`} className={style.profile_link}>
                                      <div className={`d-flex align-items-center justify-content-end ${style.profile}`}>
                                        <span>پروفایل مشاور</span>
                                        <i className={'icon-arrow-left-2'} />
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              )
                            })
                          )
                        }
                      </div>
                      {
                        showMap && selectedProperty.location && !!Object.keys(selectedProperty.location).length && (
                          <div className={style.map}>
                            <Mapbox centerCoordinator={selectedProperty.location.coordinates} />
                          </div>
                        )
                      }
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>

    );
  }
}

const mapStateToProps = (state) => ({
  selectedProperty: state.property.selectedProperty
});

const mapDispatchToProps = (dispatch) => ({
  setFilterBar: (show) => dispatch(generalActions.setFilterBar(show)),
  setSelectedProperty: (property) => dispatch(propertyActions.setSelectedProperty(property)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Detail));
